import { palette } from "./palette";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    palette: palette,
    typography: {
        // fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 600,
        htmlFontSize: 16,
        subtitle1: {
            fontSize: 15,
            fontWeight: 550,
        },
        h6: {
            fontSize: 20,
            fontWeight: 550,
        },
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    color: palette.greys.medium,
                    '&.MuiListItem-button': {
                        color: palette.greys.medium,
                        '&:hover': {
                            backgroundColor: palette.greys.light,
                            color: palette.greys.medium,
                        },
                        '&.Mui-selected': {
                            backgroundColor: palette.primary.main,
                            color: palette.greys.white,
                        },
                        '&.Mui-selected:hover': {
                            backgroundColor: palette.primary.main,
                            color: palette.greys.white,
                        },
                    },
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    border: '1px solid rgba(0, 0, 0, .125)',
                    boxShadow: 'none',
                    borderRight: 0,
                    borderLeft: 0,
                    '&:before': {
                        display: 'none',
                    },
                    '&.Mui-expanded': {
                        margin: 'auto',
                    },
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    borderBottom: '1px solid rgba(0, 0, 0, .125)',
                    marginBottom: -1,
                    minHeight: 56,
                    '&.Mui-expanded': {
                        minHeight: 56,
                    },
                    fontWeight: 'normal',
                    color: '#337AB7',
                },
                content: {
                    '&.Mui-expanded': {
                        margin: '12px 0',
                        fontWeight: 500,
                    },
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: 10,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    color: palette.primary.contrastText,
                    backgroundColor: palette.primary.main,
                    '&:hover': {
                        backgroundColor: palette.primary.dark,
                        '@media (hover: none)': {
                            backgroundColor: palette.primary.main,
                        },
                    },
                    '&:disabled': {
                        backgroundColor: palette.primary.muted,
                        color: palette.primary.contrastText,
                        opacity: 0.75,
                    },
                },
                containedSecondary: {
                    color: palette.secondary.contrastText,
                    backgroundColor: palette.secondary.main,
                    '&:hover': {
                        backgroundColor: palette.secondary.dark,
                        '@media (hover: none)': {
                            backgroundColor: palette.secondary.main,
                        },
                    },
                    '&:disabled': {
                        backgroundColor: palette.secondary.light,
                        color: palette.secondary.contrastText,
                        opacity: 0.75,
                    },
                },
            },
        },
    },
});
